import React from "react";
import Button from "../Button";
import classes from "./ModalSkeleton.module.css";
import { Modal } from "react-bootstrap";
import { CrossIcon } from "../../constant";
const ModalSkeleton = ({
  children,
  show,
  title,
  subTitle = "",
  setShow,
  onConfirm,
  isApiCall,
  confirmText,
  gapBetweenHeadAndBody = "20px",
  borderRadius = "20px",
  width = "100%",
  padding,
  position = "centered",
  isCancel = true,
}) => {
  const isCentered = position === "centered";
  return (
    <>
      <style jsx>{`
        .modal-backdrop {
          z-index: 99999 !important;
        }
        .modal {
          z-index: 99999 !important;
        }
        .modal-content {
          overflow: visible !important;
          width: 100%;

          margin: auto;
          border-radius: ${borderRadius};
          overflow: hidden;
          padding: ${padding};
          gap: ${gapBetweenHeadAndBody};
        }
        .modal-dialog {
          max-width: ${width} !important;
        }
        .modal-header {
          flex-direction: row;
          border-bottom: none;
          padding: 0px;
        }
        .modal-body {
          width: 100%;
          padding: 0px;
        }
      `}</style>
      <Modal
        backdrop="static"
        show={show}
        onHide={setShow}
        centered={isCentered}
        keyboard={false}
      >
        {title && (
          <Modal.Header>
            <div className={[classes.headerDiv].join(" ")}>
              <div>
                <h2 className={[classes.headingText].join(" ")}>{title}</h2>

                {subTitle && <p className={classes.subTitle}>{subTitle}</p>}
              </div>
              <button
                className={classes.cancelButton}
                onClick={() => {
                  if (typeof setShow === "function") {
                    setShow(false);
                  }
                }}
              >
                <CrossIcon />
              </button>
            </div>
          </Modal.Header>
        )}
        <Modal.Body>
          <div className={classes.content}>
            <>{children}</>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalSkeleton;
